var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonCircle = function SvgPersonCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#130E3A",
    d: "M5 .167c1.383 0 2.5 1.116 2.5 2.5s-1.117 2.5-2.5 2.5a2.497 2.497 0 0 1-2.5-2.5c0-1.384 1.117-2.5 2.5-2.5M5 12a6 6 0 0 1-5-2.683C.025 7.658 3.333 6.75 5 6.75c1.658 0 4.975.908 5 2.567A6 6 0 0 1 5 12"
  })));
};
export { SvgPersonCircle as ReactComponent };